import { render } from "./GamificationLeaderboard.vue?vue&type=template&id=5bce28fa&ts=true"
import script from "./GamificationLeaderboard.vue?vue&type=script&lang=ts"
export * from "./GamificationLeaderboard.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__